export default function LinkIcon() {
  return (
    <svg
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4995 5.24951L3.99112 11.866C3.7567 12.1004 3.625 12.4184 3.625 12.7499C3.625 13.0814 3.7567 13.3994 3.99112 13.6338C4.22554 13.8682 4.54348 13.9999 4.875 13.9999C5.20652 13.9999 5.52446 13.8682 5.75888 13.6338L13.5173 5.76728C13.7495 5.53513 13.9336 5.25953 14.0592 4.95622C14.1849 4.65291 14.2495 4.32782 14.2495 3.99951C14.2495 3.67121 14.1849 3.34612 14.0592 3.0428C13.9336 2.73949 13.7495 2.46389 13.5173 2.23174C13.2852 1.9996 13.0096 1.81545 12.7063 1.68981C12.4029 1.56418 12.0778 1.49951 11.7495 1.49951C11.4212 1.49951 11.0961 1.56418 10.7928 1.68981C10.4895 1.81545 10.2139 1.9996 9.98177 2.23174L2.22335 10.0982C1.52009 10.8015 1.125 11.7553 1.125 12.7499C1.125 13.7445 1.52009 14.6983 2.22335 15.4015C2.92661 16.1048 3.88044 16.4999 4.875 16.4999C5.86956 16.4999 6.82339 16.1048 7.52665 15.4015L13.937 8.99951"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
